import { colors } from "../../../styles/colors"
import { fonts } from "../../../styles/fonts"

export const paginator = {
    fontSize: 12,
    letterSpacing: 0.4,
    color: colors.black,
    fontFamily: fonts.mediumFont,
    display: 'flex',
    justifyContent: 'center',
    margin: '20px auto',

}

export const button = {
    color: colors.fuschiaPink,
    cursor: 'pointer',
}

export const nextButton = {
    ...button,
    marginLeft: 10,
    'img': {
        marginTop: -3,
        marginLeft: 5,
    }
}

export const prevButton = {
    ...button,
    marginRight: 10,
    'img': {
        marginTop: -3,
        marginRight: 5,
    }
}
